<template>
  <div>
    <editor id="tinymceEditor" :init="tinymceInit" v-model="content" :key="tinymceFlag"></editor>
  </div>
</template>
<script>
// eslint-disable-next-line

import { uploadOSS,deleteOSS } from '@/utils/oss';
const config = require('@/../vue.config');
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/icons/default/icons'
import './import-all'
// import 'tinymce/themes/modern/theme'
import 'tinymce/themes/silver/theme'
export default {
  name: 'TinymceEditor',
  props: {
    defaultContent: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 500,
    },
    width: {
      type: Number,
      default: undefined,
    },
    upload_url: {
      type: String,
      default: '',
    },
    showMenubar: {
      type: Boolean,
      default: true,
    },
    toolbar: {
      type: String,
      default: ` undo redo 
      | bold italic strikethrough underline
      | formatselect | fontselect | fontsizeselect
      | alignleft aligncenter alignright alignjustify lineheight
      | outdent indent removeformat cut copy paste blockquote subscript superscript
      | forecolor backcolor link image preview fullscreen code
      | searchreplace charmap hr
      `,
      // {
        // undo （撤销）
        // redo （重做重复）
        // formatselect （段落格式）
        // bold （加粗）
        // italic （斜体）
        // strikethrough  （删除线）

        // alignleft （左对齐）
        // aligncenter （居中对齐）
        // alignright （右对齐）
        // alignjustify （两端对齐）
        // numlist （编号列表OL）
        // bullist （项目列表UL）
        // outdent （减少缩进）
        // indent （增加缩进）
        // removeformat （清除格式）
        // lineheight （行高 5.5新增）
        // newdocument （新文档）
        // underline （下划线）
        // styleselect （格式设置）
        // fontselect （字体选择）
        // fontsizeselect （字号选择）
        // cut （剪切）
        // copy （复制）
        // paste （粘贴）
        // blockquote （引用）
        // subscript （下角标）
        // superscript （上角标）
        // forecolor backcolor formatpainter | link image  | preview fullscreen code
      // }
    },
  },
  components: {
    Editor,
  },
  data() {
    return {
      tinymceFlag: 1,
      tinymceInit: {},
      content: '',
      baseUrl:process.env.API_IMGURL,
    }
  },
  created() {
    const _this = this
    var language_url='../../../static/tinymce/langs/zh_CN.js';
    var skin_url='../../../static/tinymce/skins/ui/oxide';
    var content_css='../../../static/tinymce/skins/content/default/content.css';
    var node_env=process.env.NODE_ENV;
    if(node_env=='production'){
      
      language_url='../../..'+config.assetsPublicPath+'/static/tinymce/langs/zh_CN.js';
      skin_url='../../..'+config.assetsPublicPath+'/static/tinymce/skins/ui/oxide';
      content_css='../../..'+config.assetsPublicPath+'/static/tinymce/skins/content/default/content.css';
    }
    this.tinymceInit = {
      language_url:language_url,
      skin_url: skin_url,
      content_css: content_css,
      language: 'zh_CN',
      height: this.height,
      width: '100%',
      browser_spellcheck: true, // 拼写检查
      branding: false, // 去水印
      elementpath: false, // 禁用编辑器底部的状态栏
      statusbar: false, // 隐藏编辑器底部的状态栏
      paste_data_images: true, // 允许粘贴图像
      toolbar_mode:'wrap',
      toolbar_persist:true,
      convert_urls:false,
      // menubar: this.showMenubar, // 隐藏最上方 menu
      menubar: false, // 隐藏最上方 menu
      plugins: `link image preview fullscreen code searchreplace charmap hr`,
      // plugins: `print fullpage searchreplace autolink directionality visualblocks 
      // visualchars template codesample charmap hr pagebreak nonbreaking anchor toc insertdatetime 
      // wordcount textpattern help advlist table lists paste preview fullscreen image imagetools code link`,
      toolbar: this.toolbar,

      //   plugins:
      //     'print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave autoresize bdmap indent2em axupimgs',
      // toolbar: [
      //     'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
      //  styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
      //    table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight axupimgs'
      async images_upload_handler(blobInfo, success, failure) {
        try {
          const file = new File([blobInfo.blob()], blobInfo.filename(), {type: 'image/*'});
          var date = new Date();
          var y = date.getFullYear();    //年
          var m = date.getMonth()+1;    // 月
          var d = date.getDate();    //日
          var timestamp = date.getTime();
          let res_data = await uploadOSS('tinymce/'+(y+''+(m<10?'0'+m:m)+''+(d<10?'0'+d:d))+'/'+timestamp+file.name,file);
          success(res_data);
        } catch (e) {
          failure('上传失败');
        }
        // const file = new File([blobInfo.blob()], blobInfo.filename(), {type: 'image/*'});
        // console.log(file);
        // let formData = new FormData() 
        // formData.append('file',file);
        // var res_data = await _this.$post('upload/uploadImage', formData);
        // if(res_data){
        //   success(res_data.data);
        // }else{
        //   failure(res_data.msg);
        // }
      },
    }
  },
  mounted() {
    if (this.defaultContent) {
      this.content = this.defaultContent
    }
  },
  watch: {
    content: {
      handler() {
        this.$emit('change', this.content)
      },
    },
    defaultContent: {
      handler() {
        this.content = this.defaultContent
      },
      immediate: true,
    },
  },
  activated() {
    this.tinymceFlag++
  },
}
</script>
<style type="text/css">
.tox-silver-sink{
  z-index:3000!important;
}
.tox-toolbar__overflow{
  background-color:#fff!important;
}
p{
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/components/tinymce/index.vue